// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'polaris-solid';

export const Component = () => (
  <path d='M24.5 12.501c-3.61.375-6.422 1.453-8.344 3.281-2.203 2.016-3.422 4.922-3.656 8.719-.47-3.844-1.781-6.75-3.89-8.766C6.64 13.907 3.921 12.828.5 12.5c3.61-.281 6.422-1.406 8.437-3.375C10.953 7.11 12.125 4.251 12.5.5c.281 4.172 1.64 7.266 4.125 9.281 2.016 1.594 4.64 2.485 7.875 2.72Zm-1.5-7.5c-.891.094-1.594.374-2.157.89-.515.516-.796 1.22-.843 2.11-.094-.89-.375-1.593-.843-2.062C18.64 5.424 17.937 5.096 17 5c.891-.046 1.547-.328 2.063-.796.515-.516.843-1.266.937-2.203.047.984.375 1.734.938 2.203.515.468 1.172.75 2.062.796ZM8 20c-.938.094-1.641.374-2.157.89-.515.47-.796 1.173-.843 2.11-.094-.984-.422-1.687-.984-2.203-.422-.422-1.125-.703-2.016-.796.797-.047 1.453-.282 1.922-.704.61-.469.984-1.219 1.078-2.297.047.797.281 1.5.75 2.062.469.516 1.219.844 2.25.938Z' />
);

export const viewBox = '0 0 25 25';
